<template>
  <modal-container :id="'projectChangeBorrower'">
    <form @submit.prevent="submit">
      <div class="modal-body">
        <base-field label="Borrower">
          <base-select v-model="borrower" :model="borrowers" model-text="email" required />
        </base-field>
      </div>
      <div class="modal-footer">
        <base-button primary submit>
          Save
        </base-button>
      </div>
    </form>
  </modal-container>
</template>

<script>
import { mapState } from 'vuex'

import ModalContainer from './ModalContainer.vue'

export default {
  created () {
    this.$store.dispatch('core/users/borrowers')

    this.borrower = this.project.user._id
  },

  data: () => ({
    borrower: ''
  }),

  name: 'ProjectChangeBorrower',

  components: {
    ModalContainer
  },

  computed: {
    ...mapState({
      borrowers: store => store.core.users.borrowers,
      project: store => store.core.projects.entity
    })
  },

  methods: {
    async submit () {
      await this.$store.dispatch('core/projects/save', {
        _id: this.project._id,
        user: this.borrower
      })

      this.$modal.close('#projectChangeBorrower')
    }
  }
}
</script>
